//import FileSaver from 'file-saver';
import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'

const {
  REQUEST_ROOMS,
  REQUEST_PREVIOUS_ROOMS,
  RECEIVE_UPCOMING_ROOMS,
  SERVER_ERROR_OCURED,
  RECEIVE_PREVIOUS_ROOMS,
  SELECT_CONFERENCE,
  REQUEST_CONFERENCE_DETAILS,
  RECEIVE_CONFERENCE_DETAILS,
  REQUEST_PARTICIPANT_LIST,
  RECEIVE_PARTICIPANT_LIST,
  REQUEST_RECORD_LIST,
  RECEIVE_RECORD_LIST,
  SCHEDULE_SUBMITTED
} = actionTypes

function requestSeminarRooms () {
  return {
    type: REQUEST_ROOMS
  }
}

function receiveSeminarUpcomingRooms (upCommingRooms) {
  return {
    type: RECEIVE_UPCOMING_ROOMS,
    upCommingRooms
  }
}

function receiveSeminarPreviousRooms (previousRooms) {
  return {
    type: RECEIVE_PREVIOUS_ROOMS,
    previousRooms
  }
}

function hasErrored (bool) {
  return {
    type: SERVER_ERROR_OCURED,
    hasErrored: bool
  }
}

export function scheduleSubmitted (bool) {
  return {
    type: SCHEDULE_SUBMITTED,
    scheduleUpdated: bool
  }
}

export function selectConference (conferenceId, token) {
  return function (dispatch) {
    dispatch(scheduleSubmitted(false))
    dispatch({type: SELECT_CONFERENCE, conferenceId})
    dispatch(fetchParticipantList(token, conferenceId))
    dispatch(fetchRecordList(token, conferenceId))
  }
}

export function respondToInvitation (token, bool, conferenceId, authToken) {
  return function (dispatch) {
    fetch(
      `${config.URI}/api/v1/participants/register?register=${bool}&token=${token}`,
      {
        headers: {
          'Authenticity-Token': authToken,
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchConferenceDetails(authToken, conferenceId))
          setTimeout(() => {
            dispatch(fetchParticipantList(authToken, conferenceId))
          }, 1500)
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function fetchUpcomingSeminarRooms (token, guest, firstTime) {
  return function (dispatch, getState) {
    let url = 'api/v1/conferences?upcoming=true'
    if (guest) {
      url = 'api/v1/conferences?upcoming_guest=true'
    }
    dispatch(requestSeminarRooms())
    return fetch(`${config.URI}/${url}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const conferenceId = prevState.rooms.selectConferenceId
          const {upcoming} = prevState.rooms
          dispatch(receiveSeminarUpcomingRooms(res.data.conferences))
          if (conferenceId && upcoming && !firstTime) {
            dispatch(fetchConferenceDetails(token, conferenceId, guest))
          } else {
            dispatch(selectConference(res.data.conferences[0].id, token))
            dispatch(
              fetchConferenceDetails(token, res.data.conferences[0].id, guest)
            )
          }
        } else if (res.errors) {
          console.error(res.errors)
          dispatch(receiveSeminarUpcomingRooms([]))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function fetchPreviousSeminarRooms (token, guest) {
  return function (dispatch, getState) {
    let url = 'api/v1/conferences?previous=true'
    if (guest) {
      url = 'api/v1/conferences?previous_guest=true'
    }
    dispatch({type: REQUEST_PREVIOUS_ROOMS})
    return fetch(`${config.URI}/${url}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const conferenceId = prevState.rooms.selectConferenceId
          const {upcoming} = prevState.rooms
          dispatch(receiveSeminarPreviousRooms(res.data.conferences))
          if (conferenceId && !upcoming) {
            dispatch(fetchConferenceDetails(token, conferenceId, guest))
          } else {
            dispatch(selectConference(res.data.conferences[0].id, token))
            dispatch(
              fetchConferenceDetails(token, res.data.conferences[0].id, guest)
            )
          }
        } else if (res.errors) {
          dispatch(receiveSeminarPreviousRooms([]))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

// ComponentDidmount initial action

export function initialRoomLoad (token) {
  return function (dispatch) {
    dispatch(fetchUpcomingSeminarRooms(token))
    dispatch(fetchPreviousSeminarRooms(token))
  }
}

// Participants related actions

export function fetchParticipantList (token, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_PARTICIPANT_LIST})
    return fetch(
      `${config.URI}/api/v1/participants?conference_id=${conferenceId}`,
      {
        headers: {
          'Authenticity-Token': token,
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({
            type: RECEIVE_PARTICIPANT_LIST,
            participants: res.data.participant
          })
        } else if (res.errors) {
          console.error(res.errors)
          dispatch({type: RECEIVE_PARTICIPANT_LIST, participants: []})
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function addParticipant (token, name, email, role, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_PARTICIPANT_LIST})
    const payload = {
      name,
      email,
      role,
      conference_id: conferenceId
    }
    return fetch(`${config.URI}/api/v1/participants`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchParticipantList(token, conferenceId))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function inviteParticipant (token, participantId, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_PARTICIPANT_LIST})
    return fetch(
      `${config.URI}/api/v1/participants/invite_update/${participantId}`,
      {
        method: 'PUT',
        headers: {
          'Authenticity-Token': token,
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchParticipantList(token, conferenceId))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function importParticipants (token, contactId, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_PARTICIPANT_LIST})
    const payload = {
      conference_id: conferenceId,
      contact_id: contactId
    }
    return fetch(`${config.URI}/api/v1/participants/import`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchParticipantList(token, conferenceId))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function deleteParticipant (token, participantId, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_PARTICIPANT_LIST})
    return fetch(`${config.URI}/api/v1/participants/${participantId}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchParticipantList(token, conferenceId))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

// Recordings related actions
export function fetchRecordList (token, conferenceId) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_RECORD_LIST})
    return fetch(`${config.URI}/api/v1/records/${conferenceId}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        const prevState = getState()
        if (
          res.status &&
          res.status === 'success' &&
          prevState.rooms.selectConferenceId === conferenceId
        ) {
          if (res.data.list) {
            dispatch({
              type: RECEIVE_RECORD_LIST,
              recordings: res.data.list
            })
          } else {
            dispatch({type: RECEIVE_RECORD_LIST, recordings: []})
          }
        } else if (res.errors) {
          console.error(res.errors)
          dispatch({type: RECEIVE_RECORD_LIST, recordings: []})
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

// Conference related actions
export function fetchConferenceDetails (token, conferenceId, guest) {
  return function (dispatch) {
    dispatch({type: REQUEST_CONFERENCE_DETAILS})
    return fetch(
      `${config.URI}/api/v1/conferences/${conferenceId}${guest
        ? '?guest_show=true'
        : ''}`,
      {
        headers: {
          'Authenticity-Token': token,
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({
            type: RECEIVE_CONFERENCE_DETAILS,
            conferenceDetails: res.data.conference
          })
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function createConference (token, name, recordFlag, mobileFlag) {
  return function (dispatch, getState) {
    const payload = {
      name,
      record_flag: recordFlag,
      mobile: mobileFlag,
      bit_rate: 500000
    }
    return fetch(`${config.URI}/api/v1/conferences`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const {upcoming} = prevState.rooms
          if (upcoming) {
            dispatch(fetchUpcomingSeminarRooms(token))
          } else {
            dispatch(fetchPreviousSeminarRooms(token))
          }
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function updateConferenceDetails (
  token,
  conferenceId,
  name,
  description,
  password
) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_CONFERENCE_DETAILS})
    const payload = {
      name,
      description,
      password
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/conferences/${conferenceId}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const {upcoming} = prevState.rooms
          if (upcoming) {
            dispatch(fetchUpcomingSeminarRooms(token))
          } else {
            dispatch(fetchPreviousSeminarRooms(token))
          }
          dispatch({
            type: RECEIVE_CONFERENCE_DETAILS,
            conferenceDetails: res.data.conference
          })
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function updateConferenceSchedule (token, conferenceId, dateStart) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_CONFERENCE_DETAILS})
    const payload = {
      start_date: dateStart
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/conferences/${conferenceId}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const {upcoming} = prevState.rooms
          if (upcoming) {
            dispatch(fetchUpcomingSeminarRooms(token))
          } else {
            dispatch(fetchPreviousSeminarRooms(token))
          }
          dispatch(scheduleSubmitted(true))
          dispatch({
            type: RECEIVE_CONFERENCE_DETAILS,
            conferenceDetails: res.data.conference
          })
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function updateConferenceSettings (
  token,
  conferenceId,
  language,
  timezone,
  bitrate,
  turn,
  codec
) {
  return function (dispatch, getState) {
    dispatch({type: REQUEST_CONFERENCE_DETAILS})
    const payload = {
      language,
      timezone,
      bit_rate: bitrate,
      turn: turn,
      codec: codec
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/conferences/${conferenceId}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          const prevState = getState()
          const {upcoming} = prevState.rooms
          if (upcoming) {
            dispatch(fetchUpcomingSeminarRooms(token))
          } else {
            dispatch(fetchPreviousSeminarRooms(token))
          }
          dispatch({
            type: RECEIVE_CONFERENCE_DETAILS,
            conferenceDetails: res.data.conference
          })
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function deleteConference (token, conferenceId) {
  return function (dispatch, getState) {
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/conferences/${conferenceId}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(selectConference(null, token))
          const prevState = getState()
          const {upcoming} = prevState.rooms
          if (upcoming) {
            dispatch(fetchUpcomingSeminarRooms(token))
          } else {
            dispatch(fetchPreviousSeminarRooms(token))
          }
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/Room/actions/index.js